// src/redux/types.js

// <----------- Astrologer Get Profile -------------->
export const FETCH_ASTRO_PROFILE_REQUEST = 'FETCH_ASTRO_PROFILE_REQUEST';
export const FETCH_ASTRO_PROFILE_SUCCESS = 'FETCH_ASTRO_PROFILE_SUCCESS';
export const FETCH_ASTRO_PROFILE_FAILURE = 'FETCH_ASTRO_PROFILE_FAILURE';

// <----------- Astrologer Get Profile -------------->
export const FETCH_USER_PROFILE_REQUEST = 'FETCH_USER_PROFILE_REQUEST';
export const FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS';
export const FETCH_USER_PROFILE_FAILURE = 'FETCH_USER_PROFILE_FAILURE';

export const FETCH_CART_LIST_REQUEST = "FETCH_CART_LIST_REQUEST";
export const FETCH_CART_LIST_SUCCESS = "FETCH_CART_LIST_SUCCESS";
export const FETCH_CART_LIST_FAILURE = "FETCH_CART_LIST_FAILURE";

export const UPDATE_CART_ITEM_REQUEST = "UPDATE_CART_ITEM_REQUEST";
export const UPDATE_CART_ITEM_SUCCESS = "UPDATE_CART_ITEM_SUCCESS";
export const UPDATE_CART_ITEM_FAILURE = "UPDATE_CART_ITEM_FAILURE";

export const REMOVE_CART_ITEM_REQUEST = "REMOVE_CART_ITEM_REQUEST";
export const REMOVE_CART_ITEM_SUCCESS = "REMOVE_CART_ITEM_SUCCESS";
export const REMOVE_CART_ITEM_FAILURE = "REMOVE_CART_ITEM_FAILURE";

// for wishlist 
export const FETCH_WISHLIST_REQUEST = "FETCH_WISHLIST_REQUEST";
export const FETCH_WISHLIST_SUCCESS = "FETCH_WISHLIST_SUCCESS";
export const FETCH_WISHLIST_FAILURE = "FETCH_WISHLIST_FAILURE";
// for masterdata
export const FETCH_MASTER_DATA_REQUEST = "FETCH_MASTER_DATA_REQUEST";
export const FETCH_MASTER_DATA_SUCCESS = "FETCH_MASTER_DATA_SUCCESS";
export const FETCH_MASTER_DATA_FAILURE = "FETCH_MASTER_DATA_FAILURE";

// for settingdata
export const FETCH_SETTING_DATA_REQUEST = "FETCH_SETTING_DATA_REQUEST";
export const FETCH_SETTING_DATA_SUCCESS = "FETCH_SETTING_DATA_SUCCESS";
export const FETCH_SETTING_DATA_FAILURE = "FETCH_SETTING_DATA_FAILURE";

// for homedata
export const FETCH_HOME_DATA_REQUEST = "FETCH_HOME_DATA_REQUEST";
export const FETCH_HOME_DATA_SUCCESS = "FETCH_HOME_DATA_SUCCESS";
export const FETCH_HOME_DATA_FAILURE = "FETCH_HOME_DATA_FAILURE";

// for global searching data
export const FETCH_Global_Search_DATA_REQUEST = "FETCH_Global_Search_DATA_REQUEST";
export const FETCH_Global_Search_DATA_SUCCESS = "FETCH_Global_Search_DATA_SUCCESS";
export const FETCH_Global_Search_DATA_FAILURE = "FETCH_Global_Search_DATA_FAILURE";